import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageSquare, Bug, Lightbulb, Send, ExternalLink } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const FEEDBACK_FORM_URL = 'https://forms.gle/xt1xVnc9X8wLWKqt7';

function Feedback() {
  const navigate = useNavigate();
  const { user, profile } = useAuth();
  const [feedbackType, setFeedbackType] = useState('bug');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // For now, just redirect to the Google Form
    window.open(FEEDBACK_FORM_URL, '_blank');
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-dive-black p-6" style={{ paddingTop: 'calc(1.5rem + env(safe-area-inset-top, 0px))' }}>
      <div className="max-w-lg mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate(-1)}
            className="p-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-2xl font-display text-white">Feedback</h1>
        </div>

        {/* Icon */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 rounded-full bg-dive-neon/20 flex items-center justify-center mx-auto mb-4">
            <MessageSquare className="w-10 h-10 text-dive-neon" />
          </div>
          <h2 className="text-white text-xl font-medium mb-2">We'd Love Your Feedback!</h2>
          <p className="text-gray-400">Help us make Tilted better for everyone</p>
        </div>

        {/* Quick Links */}
        <div className="grid grid-cols-2 gap-4 mb-8">
          <a
            href={FEEDBACK_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-dive-dark rounded-xl border border-dive-gray p-4 flex flex-col items-center gap-3 hover:border-red-500/50 hover:bg-red-500/5 transition-colors group"
          >
            <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
              <Bug className="w-6 h-6 text-red-400" />
            </div>
            <span className="text-white font-medium text-sm text-center">Report a Bug</span>
            <ExternalLink className="w-4 h-4 text-gray-500 group-hover:text-red-400" />
          </a>

          <a
            href={FEEDBACK_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-dive-dark rounded-xl border border-dive-gray p-4 flex flex-col items-center gap-3 hover:border-dive-amber/50 hover:bg-dive-amber/5 transition-colors group"
          >
            <div className="w-12 h-12 rounded-full bg-dive-amber/20 flex items-center justify-center">
              <Lightbulb className="w-6 h-6 text-dive-amber" />
            </div>
            <span className="text-white font-medium text-sm text-center">Suggest a Feature</span>
            <ExternalLink className="w-4 h-4 text-gray-500 group-hover:text-dive-amber" />
          </a>
        </div>

        {/* Info Card */}
        <div className="bg-dive-dark rounded-xl border border-dive-gray p-6">
          <h3 className="text-white font-medium mb-3">What happens next?</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li className="flex items-start gap-2">
              <span className="text-dive-neon">•</span>
              We review all feedback personally
            </li>
            <li className="flex items-start gap-2">
              <span className="text-dive-neon">•</span>
              Bug fixes are prioritized based on severity
            </li>
            <li className="flex items-start gap-2">
              <span className="text-dive-neon">•</span>
              Popular feature requests get added to our roadmap
            </li>
            <li className="flex items-start gap-2">
              <span className="text-dive-neon">•</span>
              You might earn a badge for helpful feedback!
            </li>
          </ul>
        </div>

        {/* Contact Email */}
        <p className="text-center text-gray-500 text-sm mt-6">
          You can also email us directly at{' '}
          <a href="mailto:gettiltedapp@gmail.com" className="text-dive-neon hover:underline">
            gettiltedapp@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default Feedback;
